import { GridColTypeDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Chip, Tooltip } from "@mui/material";

import baseColumn from "./BaseColumn";
import { fieldLabelFormat } from "../TableUtils";

export interface ChipOptions {
  headerLabels?: Record<string, string>;
}

function chipColumn(options?: ChipOptions): GridColTypeDef {
  const chipColumn: GridColTypeDef = {
    ...baseColumn,
    type: "custom",
    renderCell: (params: GridRenderCellParams) => {
      if (params.value) {
        return (
          <Tooltip title={params.value}>
            <Chip label={params.value} variant="filled" />
          </Tooltip>
        );
      }
    }
  };
  if (options?.headerLabels) {
    chipColumn.renderHeader = fieldLabelFormat(options.headerLabels);
  }
  return chipColumn;
}

export default chipColumn;
